import { useEffect, useState, useContext, useRef } from "react";
import { Link, useNavigate } from "react-router";
import { usePostHog } from '@posthog/react';

import Logo from "../../files/logo.svg";
import LogoRect from "../../files/logo-rect.png";

import { PhysicianAvatar, Counter } from "../components/component.js";

import { AppContext } from '../../context.js';

import Assistant from "./assistant.js";
import Wall from "./wall.js";
import { Activity, Folder, Users, Speedmeter, Settings, Bank, Logout, UserPlus, FilePlus, Comment, LayerThree, Megaphone, TerminalAlt, UserCheck, ListCheck } from "../../files/icons/index.js";

function Navigation(props) {
  const { children, notificationObject } = props;

  const context = useContext(AppContext);
  const posthog = usePostHog();

  const navigate = useNavigate();
const [activePanelContent, setActivePanelContent] = useState(null); // 'wall', 'assistant', or null

  const [analyticsOpen, setAnalyticsOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);

  const analyticsRef = useRef(null);
  const profileRef = useRef(null);
  const analyticsButtonRef = useRef(null);
  const profileButtonRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (analyticsOpen &&
          analyticsRef.current &&
          !analyticsRef.current.contains(event.target) &&
          analyticsButtonRef.current &&
          !analyticsButtonRef.current.contains(event.target)) {
        setAnalyticsOpen(false);
      }

      if (profileOpen &&
          profileRef.current &&
          !profileRef.current.contains(event.target) &&
          profileButtonRef.current &&
          !profileButtonRef.current.contains(event.target)) {
        setProfileOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [analyticsOpen, profileOpen]);

  // Keyboard shortcut: Ctrl + Q to toggle main panel
  useEffect(() => {
    function handleKeyDown(event) {
      if (event.ctrlKey && (event.key === 'q' || event.key === 'й')) {
        event.preventDefault();
        setAnalyticsOpen(false);
        setProfileOpen(false);
        setActivePanelContent(prev => (prev === 'wall' || prev === 'assistant') ? null : 'wall');
      }
    }

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);



  function analytics() {
    setAnalyticsOpen(!analyticsOpen);
    setProfileOpen(false);
  }

  function profile() {
    setAnalyticsOpen(false);
    setProfileOpen(!profileOpen);
  }

  function navigateTo(path) {
    setAnalyticsOpen(false);
    setProfileOpen(false);
    navigate(path);
  }

  function logout() {
    posthog?.reset();
    context.clearState()
    navigate("/")
  }

  if (context.role === "partner") {
    return (
      <>
        <div style={{ display: 'flex' }}>
          {/* Main Content Area */}
          <div style={{ flex: 1, transition: 'all 0.3s ease' }}>
            {/* Navigation */}
            <div className="container-fluid nav">
              <div className="row">
                <div className="col-xs-12 p-2 d-flex justify-content-between align-items-center">
                  <div>
                    <Link to="/"><img src={"/api/public/logo"} alt="logo" style={{height: 50}} /></Link>
                  </div>
                  <div className="text-center">
                    <div className="d-flex d-xl-none">
                      <Link to={'/referrals'} className="item typo-body-medium"><UserPlus height={16} width={16} color={'grey'} /> Referrals</Link>
                      <div to={'/services'} className="item typo-body-medium" style={{opacity: 0.4, cursor: 'not-allowed'}}><UserPlus height={16} width={16} color={'grey'} /> Services</div>
                      <div to={'/accounting'} className="item typo-body-medium" style={{opacity: 0.4, cursor: 'not-allowed'}}><UserPlus height={16} width={16} color={'grey'} /> Accounting</div>
                    </div>
                    <div className="d-none d-xl-flex">
                      <Link to={'/referrals'} className="item typo-body-medium"><UserPlus height={16} width={16} color={'grey'} /> Referrals</Link>
                      <div to={'/services'} className="item typo-body-medium ms-2" style={{opacity: 0.4, cursor: 'not-allowed'}}><FilePlus height={16} width={16} color={'grey'} /> Services</div>
                      <div to={'/accounting'} className="item typo-body-medium ms-2" style={{opacity: 0.4, cursor: 'not-allowed'}}><Bank height={16} width={16} color={'grey'} /> Accounting</div>
                    </div>
                  </div>
                  <div className="text-end">
                    <div className="item typo-body-medium" onClick={logout}><Logout height={16} width={16} color={'grey'} /> Logout</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Main Content */}
            <div className="con">
              {children}
            </div>
          </div>
        </div>
      </>
    );
  }

  if (context.role === "physician" || context.role === "bot") {
    return (
      <>
        <div style={{ display: 'flex' }}>
          {/* Left Sidebar - Always visible 60px */}
          <div
            className="noprint"
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '60px',
              height: '100vh',
              backgroundColor: 'white',
              borderRight: '1px solid #e0e0e0',
              overflow: 'hidden',
              zIndex: 1000
            }}
          >
            <div style={{height: '100%', padding: '.5rem', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
              {/* Top section: Logo + Navigation */}
              <div>
                {/* Sidebar Top */}
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px'}}>
                  <img src={LogoRect} alt="logo" style={{height: '30px', width: '30px'}} />
                  <div className={"item py-2 " + (activePanelContent === 'wall' ? 'grey' : '')} onClick={() => setActivePanelContent(prev => prev === 'wall' ? null : 'wall')}>
                    <LayerThree height={22} width={22} color={'grey'} />
                  </div>
                  <div className={"item py-2 " + (activePanelContent === 'assistant' ? 'grey' : '')} onClick={() => setActivePanelContent(prev => prev === 'assistant' ? null : 'assistant')}>
                    <TerminalAlt height={22} width={22} color={'grey'} />
                  </div>
                </div>
              </div>

              {/* Sidebar Bottom */}
              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px'}}>
                <div className="item py-2" onClick={() => navigate('/feedback')}><Megaphone height={22} width={22} color={'grey'} /></div>
                <div className="item py-2" onClick={() => navigate('/settings')}><Settings height={22} width={22} color={'grey'} /></div>
              </div>
            </div>
          </div>

          {/* Central Expandable Panel - 0 to 20% */}
          <div
            className="noprint"
            style={{
              position: 'fixed',
              top: 0,
              left: '60px',
              width: activePanelContent ? '20%' : '0',
              height: '100vh',
              backgroundColor: '#fff',
              transition: 'width 0.3s ease',
              overflow: 'hidden',
              zIndex: 999,
              borderRight: activePanelContent ? '1px solid #e0e0e0' : 'none'
            }}
          >
            {activePanelContent === 'wall' && (
              <div style={{height: '100%', padding: '20px'}}>
                <Wall />
              </div>
            )}
            {activePanelContent === 'assistant' && (
              <div style={{height: '100%', padding: '20px'}}>
                <Assistant />
              </div>
            )}
          </div>

          {/* Main Application Content Area */}
          <div style={{ flex: 1, transition: 'all 0.3s ease', marginLeft: activePanelContent ? 'calc(60px + 20%)' : '60px' }}>
            {/* Analytics submenu */}
            <div ref={analyticsRef} className={"card shadowmore " + (analyticsOpen ? "" : "d-none")} style={{position: 'absolute', top: '45px', left: '50%', transform: 'translateX(-50%)', width: '50%', zIndex: 9999}}>
              <div className="card-content sm">
                <div className="row mb-2">
                  <div className="col-xs-3">
                    <div className="typo-strong-175 ms-2">Users</div>
                    <div className="item typo-normal-150" onClick={() => navigateTo('/analytics/users/assignment-overview')}>Assignment Overview</div><br/>
                  </div>
                  <div className="col-xs-3">
                    <div className="typo-strong-175 ms-2">Patients</div>
                    <div className="item typo-normal-150" onClick={() => navigateTo('/analytics/patients/statistics')}>Patient Analytics Dashboard</div><br/>
                    <div className="item typo-normal-150" onClick={() => navigateTo('/analytics/patients/source-overview')}>Patient Source Overview</div><br/>
                  </div>
                  <div className="col-xs-3">
                    <div className="typo-strong-175 ms-2">Projects</div>
                    <div className="item typo-normal-150" onClick={() => navigateTo('/analytics/projects/statistics')}>Project Analytics Dashboard</div><br/>
                  </div>
                  <div className="col-xs-3">
                    <div className="typo-strong-175 ms-2">Referrals</div>
                    <div className="item typo-normal-150" onClick={() => navigateTo('/analytics/referrals/statistics')}>Referral Analytics Dashboard</div><br/>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-3">
                    <div className="typo-strong-175 ms-2">Accounting</div>
                    <div className="item typo-normal-150" onClick={() => navigateTo('/analytics/accounting/statistics')}>Partner Accounting</div><br/>
                  </div>
                  <div className="col-xs-3">
                    <div className="typo-strong-175 ms-2">Reports</div>
                    <div className="item typo-normal-150" onClick={() => navigateTo('/analytics/reports/paaf')}>PAAF</div><br/>
                  </div>
                </div>
              </div>
            </div>

            {/* Profile submenu */}
            <div ref={profileRef} className={"card shadowmore " + (profileOpen ? "" : "d-none")} style={{position: 'absolute', top: '45px', right: '32px', width: '200px'}}>
              <div className="card-header sm">
                <div onClick={() => navigateTo('/profile/settings')} className="side-item typo-strong-150"><Settings height={16} width={16} color={'grey'} /> Settings</div>
              </div>
                <div className="card-content sm">
                <div onClick={logout} className="side-item typo-strong-150"><Logout height={16} width={16} color={'grey'} /> Logout</div>
              </div>
            </div>

            {/* Navigation */}
            <div className="container-fluid nav">
              <div className="row">
                <div className="col-xs-12 p-2 d-flex justify-content-between align-items-center">
                  <div>
                    <Link to="/"><img src={"/api/public/logo"} alt="logo" style={{height: 32}} /></Link>
                  </div>
                  <div className="text-center">
                    <div className="d-flex d-xl-none">
                      <Link to={'/'} className="item typo-body-medium"><Activity height={16} width={16} color={'grey'} /> Dashboard</Link>
                      <Link to={'/referrals'} className="item typo-body-medium ms-2"><UserPlus height={16} width={16} color={'grey'} /> Referrals {notificationObject && notificationObject.referrals > 0 && <Counter color="red" text={notificationObject.referrals} />}</Link>
                      <Link to={'/patients'} className="item typo-body-medium ms-2"><Users height={16} width={16} color={'grey'} /> Patients</Link>
                    </div>
                    <div className="d-none d-xl-flex">
                      <Link to={'/'} className="item typo-body-medium"><Activity height={16} width={16} color={'grey'} /> Dashboard</Link>
                      {/* <Link to={'/intakes'} className="item typo-body-medium ms-2"><UserCheck height={16} width={16} color={'grey'} /> Intakes</Link> */}
                      <Link to={'/referrals'} className="item typo-body-medium ms-2"><UserPlus height={16} width={16} color={'grey'} /> Referrals {notificationObject && notificationObject.referrals > 0 && <Counter color="red" text={notificationObject.referrals} />}</Link>
                      <Link to={'/patients'} className="item typo-body-medium ms-2"><Users height={16} width={16} color={'grey'} /> Patients</Link>
                      <Link to={'/accounting'} className="item typo-body-medium ms-2"><Bank height={16} width={16} color={'grey'} /> Accounting</Link>
                      {context.features?.claims && (
                        <Link to={'/claims'} className="item typo-body-medium ms-2"><ListCheck height={16} width={16} color={'grey'} /> Claims</Link>
                      )}
                      <div ref={analyticsButtonRef} className="item typo-body-medium ms-2" onClick={() => analytics()}><Speedmeter height={16} width={16} color={'grey'} /> Analytics</div>
                    </div>
                  </div>
                  <div className="text-end">
                    {/* {context.role === "physician" && (
                      <Link to={'/inbox'} className="item typo-body-medium me-2"><Inbox height={16} width={16} color={'grey'} />Inbox <Counter color="red" text="21" /></Link>
                    )} */}
                    {/* {context.role === "physician" && (
                      // <Notification events={notificationObject ? notificationObject.events : []} />
                      <Notification events={[]} />
                    )} */}
                    <div ref={profileButtonRef} className="item typo-body-medium" onClick={() => profile()}><PhysicianAvatar id={context.id} />{(context.scale === "xl" || context.scale === "xxl") ? context.name : ""}</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Main Content */}
            <div className="con">
              {children}
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
      <>
        <div style={{ display: 'flex' }}>
          {/* Left Sidebar */}
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: sidebarVisible ? '15%' : '0',
              minWidth: sidebarVisible ? '200px' : '0',
              height: '100vh',
              backgroundColor: '#f5f5f5',
              transition: 'width 0.3s ease, min-width 0.3s ease',
              overflow: 'hidden',
              zIndex: 999
            }}
          >
            {sidebarVisible && (
              <div style={{ height: '100%', overflowY: 'auto' }}>
                {/* Sidebar content goes here */}
              </div>
            )}
          </div>

          {/* Main Content Area */}
          <div style={{ flex: 1, transition: 'all 0.3s ease', marginLeft: sidebarVisible ? 'max(15%, 200px)' : '0' }}>
            {/* Navigation */}
            <div className="container-fluid nav">
              <div className="row">
                <div className="col-xs-12 p-2 d-flex justify-content-between align-items-center">
                  <div>
                    <Link to="/"><img src={"/api/public/logo"} alt="logo" style={{height: 50}} /></Link>
                  </div>
                  <div className="text-center">
                    <div className="d-flex d-xl-none ">
                      <Link to={'/'} className="item typo-body-medium disabled"><Activity height={16} width={16} color={'grey'} /> Dashboard</Link>
                      <Link to={'/projects'} className="item typo-body-medium ms-2"><Folder height={16} width={16} color={'grey'} /> Projects {notificationObject && notificationObject.projects > 0 && <Counter color="red" text={notificationObject.projects} />}</Link>
                      <Link to={'/patients'} className="item typo-body-medium ms-2"><Users height={16} width={16} color={'grey'} /> Patients {notificationObject && notificationObject.forms > 0 && <Counter color="red" text={notificationObject.forms} />}</Link>
                    </div>
                    <div className="d-none d-xl-flex ">
                      <Link to={'/'} className="item typo-body-medium disabled"><Activity height={16} width={16} color={'grey'} /> Dashboard</Link>
                      <Link to={'/projects'} className="item typo-body-medium ms-2"><Folder height={16} width={16} color={'grey'} /> Projects {notificationObject && notificationObject.projects > 0 && <Counter color="red" text={notificationObject.projects} />}</Link>
                      <Link to={'/patients?tab=patients'} className="item typo-body-medium ms-2"><Users height={16} width={16} color={'grey'} /> Patients {notificationObject && notificationObject.forms > 0 && <Counter color="red" text={notificationObject.forms} />}</Link>
                      <Link to={'/accounting'} className="item typo-body-medium ms-2"><Bank height={16} width={16} color={'grey'} /> Accounting</Link>
                      <Link to={'/analytics/paaf'} className="item typo-body-medium ms-2"><Speedmeter height={16} width={16} color={'grey'} /> Analytics</Link>
                    </div>
                  </div>
                  <div className="text-end">
                    <Link to={'/profile/personal'} className="item typo-body-medium"><PhysicianAvatar id={context.id} />{(context.scale === "xl" || context.scale === "xxl") ? context.name : ""}</Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Main Content */}
            <div className="con">
              {children}
            </div>
          </div>
        </div>
      </>
    );
}

export default Navigation;